import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import { BatchReSubmitClaim, getMasterData, downloadResubmitBatchEDI837 } from './actions/ManageClaimActions';
import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';

import { renderAutoCompleteSingleSelect, renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';

// import validate from './ValidateSubmitClaim';

const validate = (values) => {
  const errors = {};
  if (values.Claim && values.Claim.length) {
    const ClaimArrayErrors = [];
    values.Claim.forEach((ClaimObj, index) => {
      const ClaimErrors = {};
      if (!ClaimObj.resubmissionReasonId) {
        ClaimErrors.resubmissionReasonId = 'Please select resubmission reason';
        ClaimArrayErrors[index] = ClaimErrors;
      }
      if (!ClaimObj.controlReferenceNumber) {
        ClaimErrors.controlReferenceNumber = 'Please enter control reference number';
        ClaimArrayErrors[index] = ClaimErrors;
      }
    });
    if (ClaimArrayErrors.length) {
      errors.Claim = ClaimArrayErrors;
    }
  }
  return errors;
};

class BatchResubmitClaimModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      isDownloadEDI: props.isDownloadEDI ? true : false,
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillMount() {    
    let masterData = { 'masterdata': 'CLAIMRESUBMISSIONREASON' };
    this.props.getMasterData(masterData);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterPractitionerList: masterData.allStaffs,
      });
    }

    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord, index) => {    
    if(selectedRecord.label === '1 - Original Claim')
    {
      this.props.dispatch(change('BatchResubmitClaimModal', `Claim[${index}].controlReferenceNumber`, null));
    }
    else
    {
      this.props.dispatch(change('BatchResubmitClaimModal', `Claim[${index}].controlReferenceNumber`, this.props.selectedEDIClaimsPayerControlNumber[index]));
    }
    input.onChange(selectedRecord.value);
  }
  handleSelectAllRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    let self = this;
    (this.props.selectedBatchClaimArray || []).map((claimObj, index) => {
      self.props.dispatch(change('BatchResubmitClaimModal', `Claim[${index}].resubmissionReasonId`, selectedRecord.value));
      self.props.dispatch(change('BatchResubmitClaimModal', `Claim[${index}].controlReferenceNumber`, this.props.selectedEDIClaimsPayerControlNumber[index]));
    });
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let postData = (formData.Claim || []).map((obj) => {
      let reasonObj = (this.props.resubmissionReason || []).find((reasonObj) => reasonObj.id === obj.resubmissionReasonId);
      return {
        claimId: obj.claimId,
        resubmissionReason: reasonObj && reasonObj.resubmissionReason,
        payerControlReferenceNumber: (reasonObj.resubmissionReason !== 'OR') ? obj.controlReferenceNumber : null,
        isEncounterClaim: this.state.isDownloadEDI ? formData.IsEncounterClaim : false,
      };
    });

    // console.log(JSON.stringify(postData));
    if(this.state.isDownloadEDI)    
      this.props.downloadResubmitBatchEDI837(postData);
    else
      this.props.BatchReSubmitClaim(postData);

    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  renderClaimsData() {
    let selectorClaims = this.props.selectorClaims || [];
    return (this.props.selectedBatchClaimArray || []).map((claimObj, index) => {
      let isControlRefShow = false;
      let selectedResubmissionReasonId = selectorClaims[index] && selectorClaims[index].resubmissionReasonId;
      if (selectedResubmissionReasonId) {
        let reasonObj = (this.props.resubmissionReason || []).find((obj) => obj.id === selectedResubmissionReasonId);
        isControlRefShow = (reasonObj && (reasonObj.resubmissionReason === 'CR' || reasonObj.resubmissionReason === 'VR' || reasonObj.resubmissionReason === 'RR')) ? true : false;
      }
      return (
        <tr key={index}>
          <td>
            {`CL${claimObj}`}
          </td>
          <td>
            <div className="mt-35">
              <Field
                name={`Claim[${index}].resubmissionReasonId`}
                label=''
                options={this.props.resubmissionReason}
                handleNewRequest={(input, selectedRecord)=>this.handleNewRequest(input, selectedRecord, index)}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
          </td>
          <td>
            {isControlRefShow &&
              <div className="require">
                <Field
                  name={`Claim[${index}].controlReferenceNumber`}
                  hintText='Control Reference Number'
                  fullWidth={true}
                  maxLength={20}
                  component={renderTextField}
                />
              </div>
            }
          </td>
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
      <CommonButton type="submit" primary={true} label={this.state.isDownloadEDI ? 'Download Claim(s)' : 'Resubmit Claim(s)'} onTouchTap={handleSubmit(this.onSubmitHandler)} />,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.state.isDownloadEDI ? 'Download Batch EDI Claim(s) For Resubmission' : 'Resubmit Batch EDI Claim(s)'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className='mt-2'style={{color:"black"}}>
                  <em>
                    *Please note, most payers require code "7" for correcting a submitted claim. Check with your payer for the appropriate code.
                  </em>
                </div>
                <div className="col-sm-12">
                  <div className="table-responsive mt-15">
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="20%">Claim ID</th>
                          <th width="40%">Resubmission Reason
                            <Field
                              name={'ClaimResubmissionReasonId'}
                              label=''
                              options={this.props.resubmissionReason}
                              handleNewRequest={this.handleSelectAllRequest}
                              component={renderAutoCompleteSingleSelect}
                            />
                          </th>
                          {this.state.isDownloadEDI ? 
                          <th width="40%">
                            <Field
                              name="IsEncounterClaim"
                              label="Download As Encounter Claims"
                              // defaultChecked={this.state.IsClaimForm1500 ? false : true}
                              component={renderCheckBox} />
                          </th>
                          : <th width="40%">Control Reference Number</th> }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderClaimsData()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-6 require mt-40">
                </div>
                <div className="col-sm-6 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel" onTouchTap={this.handleClose} />
                  <FlatButton className="blue_btn"
                    label="Resubmit Claim(s)" primary={true} type='submit' />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

BatchResubmitClaimModal = reduxForm({
  form: 'BatchResubmitClaimModal',
  validate,
  enableReinitialize: true,
})(BatchResubmitClaimModal);

const selector = formValueSelector('BatchResubmitClaimModal');
function mapStateToProps(state, ownProps) {
  let resubmissionReason = [], initialValueData = null, defaultSubmissionReasonId = null;
  if (state.billing.master_data && state.billing.master_data.claimResubmissionReason) {
    resubmissionReason = state.billing.master_data.claimResubmissionReason.map((obj) => {

      if ((obj.value || '').toLowerCase() === 'original claim') {
        defaultSubmissionReasonId = obj.id;
      }
      return {
        id: obj.id,
        value: obj.resubmissionCode + ' - ' + obj.description,
        resubmissionReason: obj.resubmissionReason,
      };
    });
  }
  if (ownProps.selectedBatchClaimArray) {
    initialValueData = {
      Claim: (ownProps.selectedBatchClaimArray || []).map((claimObj) => {
        return {
          claimId: claimObj,
          resubmissionReasonId: defaultSubmissionReasonId,
        };
      }),
    };
  }
  return {
    loading: state.billing.loading,
    resubmissionReason: resubmissionReason,
    initialValues: initialValueData,
    selectorClaims: selector(state, 'Claim'),
  };
}

export default connect(mapStateToProps, { BatchReSubmitClaim, getMasterData, downloadResubmitBatchEDI837 })(BatchResubmitClaimModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BatchResubmitClaim_Modal.js